import React from 'react';
/**
 * DjayAvatar part — arms per emotion (with small-size stubs fallback).
 * Verbatim extraction of the former `renderArms()`.
 */
import type { DjayEmotion, VariantColorScheme } from '../types';
interface ArmsProps {
  emotion: DjayEmotion;
  colors: VariantColorScheme;
  showFullArms: boolean;
  showArmStubs: boolean;
}
export function Arms({
  emotion,
  colors,
  showFullArms,
  showArmStubs
}: ArmsProps) {
  if (!showFullArms && !showArmStubs) return null;
  if (showArmStubs) return <g className="djay-arms-stubs" data-id="element-3139">
        <circle cx="38" cy="125" r="8" fill={colors.armColor} data-id="element-3140" />
        <circle cx="162" cy="125" r="8" fill={colors.armColor} data-id="element-3141" />
      </g>;
  switch (emotion) {
    case 'pointing':
      return <>
          <g className="djay-arm-left" data-id="element-3142">
            <ellipse cx="42" cy="135" rx="14" ry="18" fill={colors.armColor} transform="rotate(15 42 135)" data-id="element-3143" />
          </g>
          <g className="djay-arm-right" style={{
          transformOrigin: '150px 120px'
        }} data-id="element-3144">
            <ellipse cx="165" cy="120" rx="22" ry="12" fill={colors.armColor} transform="rotate(-10 165 120)" data-id="element-3145" />
            <path d="M175 118 L192 115" stroke={colors.armColor} strokeWidth="10" strokeLinecap="round" data-id="element-3146" />
            <path d="M175 118 L192 115" stroke={colors.armHighlight} strokeWidth="4" strokeLinecap="round" data-id="element-3147" />
            <ellipse cx="170" cy="118" rx="8" ry="6" fill={colors.armHighlight} transform="rotate(-10 170 118)" data-id="element-3148" />
          </g>
        </>;
    case 'celebrating':
    case 'excited':
    case 'proud':
      return <>
          <g className="djay-arm-left" data-id="element-3149">
            <ellipse cx="40" cy="90" rx="14" ry="25" fill={colors.armColor} transform="rotate(35 40 90)" data-id="element-3150" />
            <ellipse cx="32" cy="75" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(35 32 75)" data-id="element-3151" />
          </g>
          <g className="djay-arm-right" data-id="element-3152">
            <ellipse cx="160" cy="90" rx="14" ry="25" fill={colors.armColor} transform="rotate(-35 160 90)" data-id="element-3153" />
            <ellipse cx="168" cy="75" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-35 168 75)" data-id="element-3154" />
          </g>
        </>;
    case 'thinking':
      return <>
          <g className="djay-arm-left" data-id="element-3155">
            <ellipse cx="42" cy="135" rx="14" ry="18" fill={colors.armColor} transform="rotate(15 42 135)" data-id="element-3156" />
          </g>
          <g className="djay-arm-right" data-id="element-3157">
            <ellipse cx="135" cy="135" rx="14" ry="22" fill={colors.armColor} transform="rotate(-45 135 135)" data-id="element-3158" />
            <ellipse cx="125" cy="120" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-45 125 120)" data-id="element-3159" />
          </g>
        </>;
    case 'surprised':
      return <>
          <g className="djay-arm-left" data-id="element-3160">
            <ellipse cx="30" cy="125" rx="18" ry="14" fill={colors.armColor} transform="rotate(-20 30 125)" data-id="element-3161" />
          </g>
          <g className="djay-arm-right" data-id="element-3162">
            <ellipse cx="170" cy="125" rx="18" ry="14" fill={colors.armColor} transform="rotate(20 170 125)" data-id="element-3163" />
          </g>
        </>;
    case 'sleeping':
      return <>
          <g className="djay-arm-left" data-id="element-3164">
            <ellipse cx="55" cy="145" rx="16" ry="12" fill={colors.armColor} transform="rotate(20 55 145)" data-id="element-3165" />
          </g>
          <g className="djay-arm-right" data-id="element-3166">
            <ellipse cx="145" cy="145" rx="16" ry="12" fill={colors.armColor} transform="rotate(-20 145 145)" data-id="element-3167" />
          </g>
        </>;
    case 'encouraging':
      return <>
          <g className="djay-arm-left" data-id="element-3168">
            <ellipse cx="42" cy="125" rx="18" ry="22" fill={colors.armColor} transform="rotate(-20 42 125)" data-id="element-3169" />
          </g>
          <g className="djay-arm-right" data-id="element-3170">
            <ellipse cx="165" cy="135" rx="20" ry="14" fill={colors.armColor} transform="rotate(-15 165 135)" data-id="element-3171" />
            <ellipse cx="175" cy="130" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-15 175 130)" data-id="element-3172" />
          </g>
        </>;
    case 'happy':
    default:
      return <>
          <g className="djay-arm-left" data-id="element-3173">
            <ellipse cx="42" cy="125" rx="18" ry="22" fill={colors.armColor} transform="rotate(-20 42 125)" data-id="element-3174" />
            <ellipse cx="38" cy="118" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-20 38 118)" data-id="element-3175" />
          </g>
          <g className="djay-arm-right" data-id="element-3176">
            <ellipse cx="158" cy="130" rx="18" ry="22" fill={colors.armColor} transform="rotate(15 158 130)" data-id="element-3177" />
            <ellipse cx="154" cy="123" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(15 154 123)" data-id="element-3178" />
          </g>
        </>;
  }
}